// extracted by mini-css-extract-plugin
export default {"wrapper":"Bq-z","response":"Cq-z","error":"Dq-z","disabled":"Eq-z","buttons":"Fq-z","feedbackQuestionSection":"Gq-z","yesNoWrapper":"Hq-z"};